import 'normalize.css/normalize.css';// A modern alternative to CSS resets
import '@/styles/iview.less';

import Vue from 'vue';
import VueAxios from 'vue-axios';
import VueMeta from 'vue-meta';
import iView from '@/lib/iview';
import GDL from '@/lib/gdl';
import { sync } from 'vuex-router-sync';

import http from '@/http';
import store from '@/store';
import router from '@/router';
import i18n from '@/i18n';

import AuthService from '@/services/auth';
import ErrorReporter from '@/services/error-reporter';
import VeeValidate from '@/services/vee-validate';

import '@/router/interceptors';

import VueBreadcrumb from '@/plugins/breadcrumb';

import App from './App.vue';

if (process.env.NODE_ENV !== 'production') { require('@/utils/dev') }; // eslint-disable-line

AuthService.init();
ErrorReporter.configure({ enabled: true });

Vue.use(VueAxios, http);
Vue.use(VueMeta);
Vue.use(iView, {
  i18n: (path, options) => i18n.t(path, options),
  transfer: true,
});
Vue.use(VueBreadcrumb);
Vue.use(VeeValidate, { inject: false });
Vue.use(GDL);

sync(store, router);

Vue.config.productionTip = false;

if (process.env.NODE_ENV !== 'production') {
  Vue.config.devtools = true;
  Vue.config.performance = true;
}

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app');
